<template>
  <transition name="product">
    <div class="ClueQuery">
      <van-nav-bar fixed title="注册" left-arrow @click-left="$router.go(-1)"></van-nav-bar>
      <div>
        <div class="main-content" v-if="zhucetype=='招商顾问'">
          <van-form @submit="onSubmit">
            <!-- 注册类型 -->
            <van-field
              readonly
              clickable
              name="zhucetype"
              :value="zhucetype"
              label="注册类型"
              @click="showPicker = true"
            />
            <van-field v-model="form.username" name="userName" label="姓名" placeholder="请输入姓名" />
            <van-field
              v-model="form.code"
              name="code"
              label="身份证号"
              placeholder="请输入身份证号"
              :error-message="erroridcode"
              @input="valiidcard"
            />
            <van-field
              v-model="form.businessOrg"
              name="businessOrg"
              label="用户单位"
              placeholder="请输入用户单位"
              :rules="[{ required: true, message: '请填写用户单位' }]"
            />
            <van-field
              v-model="form.password1"
              type="password"
              name="password1"
              label="密码"
              placeholder="请输入密码"
            />
            <van-field
              type="password"
              v-model="form.password2"
              name="password2"
              label="确认密码"
              placeholder="请输入确认密码"
              :error-message="errorpassword"
              @input="valiidpassword"
            />
            <van-field
              v-model="form.email"
              name="email"
              label="邮箱"
              placeholder="请输入邮箱"
              :error-message="erroremail"
              @input="valiiderroremail"
            />
            <van-field
              v-model.number="form.tel"
              name="tel"
              label="手机"
              placeholder="请输入手机号"
              :error-message="errortel"
              @input="valiiderrortel"
              use-button-slot
            >
            <van-button slot="button" size="small" type="primary" @click="sendCode();return false;"  >
              <div v-if="countTime == 0">发送验证码</div>
              <div  v-else>{{ countTime }}</div>
      
    </van-button>
          </van-field> 
            <van-field
              v-show="errcode"
              v-model="form.messageCheckCode"
              name="messageCheckCode"
              label="短信验证码"
              placeholder="请输入短信验证码"
              :error-message="errorCheckCode"
              @input="valiiderrorCheckCode"
          > </van-field>
            <div style="margin: 16px">
              <van-button round block type="info" native-type="onSubmit">注册账号</van-button>
            </div>
          </van-form>
        </div>

        <div v-if="zhucetype=='平台用户'">
          <van-form @submit="onSubmit2">
            <!-- 注册类型 -->
            <van-field
              readonly
              clickable
              name="zhucetype"
              :value="zhucetype"
              label="注册类型"
              @click="showPicker = true"
            />
            <van-field v-model="form2.userName" name="userName" label="姓名" placeholder="请输入姓名" />
            <van-field
              v-model="form2.code"
              name="code"
              label="身份证号"
              placeholder="请输入身份证号"
              :error-message="erroridcode"
              @input="valiidcard2"
            />
            <!-- 部门类型 -->
            <van-field
              readonly
              clickable
              name="bumenid"
              :value="bumenid"
              :value-key="text"
              label="部门"
              placeholder="请选择部门"
              @click="isbumen = true"
            />
            <div v-if="bumenval!=''">
              <van-field
                readonly
                clickable
                name="keshiid"
                :value="keshiid"
                :value-key="text"
                label="科室"
                placeholder="请选择科室"
                @click="iskeshi = true"
              />
            </div>

            <!-- 职务 -->
            <van-field
              readonly
              clickable
              name="zhiwuid"
              :value="zhiwuid"
              :value-key="text"
              label="职务"
              placeholder="请选择职务"
              @click="iszhiwu = true"
            />
            <van-field
              v-model="form2.password"
              type="password"
              name="password1"
              label="密码"
              placeholder="请输入密码"
            />
            <van-field
              type="password"
              v-model="form2.password1"
              name="password2"
              label="确认密码"
              placeholder="请输入确认密码"
              :error-message="errorpassword"
              @input="valiidpassword2"
            />
            <van-field
              v-model="form2.email"
              name="email"
              label="邮箱"
              placeholder="请输入邮箱"
              :error-message="erroremail"
              @input="valiiderroremail2"
            />
            <van-field
              v-model.number="form2.tel"
              name="tel"
              label="手机"
              placeholder="请输入手机号"
              :error-message="errortel"
              @input="valiiderrortel2"
              use-button-slot
            >
            <van-button slot="button" size="small" type="primary" @click="sendCode2();return false;" >
              <div v-if="countTime == 0">发送验证码</div>
              <div  v-else>{{ countTime }}</div>
    </van-button>
          </van-field> 
            
            <van-field
              v-show="errcode"
              v-model="form2.messageCheckCode"
              name="messageCheckCode"
              label="短信验证码"
              placeholder="请输入短信验证码"
              :error-message="errorCheckCode"
              @input="valiiderrorCheckCode"
            >
          </van-field> 
            <div style="margin: 16px">
              <van-button round block type="info" native-type="onSubmit">注册账号</van-button>
            </div>
          </van-form>
        </div>
      </div>

      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>

      <van-popup v-model="isbumen" position="bottom">
        <van-picker
          show-toolbar
          :columns="bumencolumns"
          @confirm="bumenonConfirm"
          @cancel="isbumen = false"
        />
      </van-popup>

      <van-popup v-model="iskeshi" position="bottom">
        <van-picker
          show-toolbar
          :columns="keshicolumns"
          @confirm="keshiConfirm"
          @cancel="iskeshi = false"
        />
      </van-popup>

      <van-popup v-model="iszhiwu" position="bottom">
        <van-picker
          show-toolbar
          :columns="zhiwulist"
          @confirm="zhiwuConfirm"
          @cancel="iszhiwu = false"
        />
      </van-popup>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      zhiwulist: [
        {
          text: "科员",
          value: "科员"
        },
        {
          text: "科长",
          value: "科长"
        },
        {
          text: "分管领导",
          value: "分管领导"
        },
        {
          text: "主管领导",
          value: "主管领导"
        }
      ],
      bumenval: "",
      bumencolumns: [],
      keshicolumns: [],
      isbumen: false,
      iskeshi: false,
      iszhiwu: false,
      errcode: false,
      zhucetype: "招商顾问", //默认类型为招商顾问
      showPicker: false,
      columns: ["招商顾问", "平台用户"],
      //招商顾问form
      form: {
        username: "",
        code: "",
        businessOrg: "",
        password1: "",
        password2: "",
        email: "",
        tel: "",
        checkCode: "",
        messageCheckCode: ""
      },
      form2: {
        //平台用户
        tel: "",
        userName: "",
        code: "",
        email: "",
        orgId: 0, //平台用户的单位
        password: "",
        password1: "",
        checkCode: "",
        messageCheckCode: "",
        posinion: "" //平台用户的职务
      },
      bumenid: "",
      keshiid: "",
      zhiwuid: "",
      erroridcode: "",
      errorpassword: "",
      erroremail: "",
      errortel: "",
      errorCheckCode: "",
      src: "",
      src2: "",
      errtel: null,
      countTime: 0,
      stopSend: false
    };
  },
  methods: {
    onConfirm(value) {
      console.log(value, 6699);
      this.zhucetype = value;
      this.showPicker = false;
    },
    //招商用户注册
    onSubmit(values) {
      console.log("submit", values);
      this.request({
        url: "/v1.0/Account/BusinessUserRegedit",
        method: "POST",
        data: values
      }).then(res => {
        console.log(res, 6333);
        if (res.data.indexOf("成功") > 0) {
          this.$message.success("你已注册成功，请等待管理员审核才能登陆!");
          this.$router.go(-1);
        } else {
          this.$message.error(res.data);
        }
      });
    },
    //平台用户注册
    onSubmit2() {
       let values={
          checkCode:this.form2.checkCode,
          code:this.form2.code,
          email:this.form2.email,
          messageCheckCode:this.form2.messageCheckCode,
          orgId:this.form2.orgId,
          password:this.form2.password,
          password1:this.form2.password1,
          posinion:this.form2.posinion,
          tel:this.form2.tel,
          userName:this.form2.userName
       }
       this.request({
        url: "/v1.0/Account/InputRegeditUser",
        method: "POST",
        data: values
      }).then(res => {
        console.log(res, 6333);
        if (res.data.indexOf("成功") > 0) {
          this.$message.success("你已注册成功，请等待管理员审核才能登陆!");
          this.$router.go(-1);
        } else {
          this.$message.error(res.data);
        }
      });
    },
    //验证身份证
    valiidcard() {
      console.log(1);
      let idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
      if (this.form.code === "") {
        this.erroridcode = "请输入身份证号";
        return false;
      }
      if (!idcardReg.test(this.form.code)) {
        this.erroridcode = "请输入正确的身份证号";
        return false;
      }
      this.erroridcode = "";
    },
    valiidcard2() {
      let idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
      if (this.form2.code === "") {
        this.erroridcode = "请输入身份证号";
        return false;
      }
      if (!idcardReg.test(this.form2.code)) {
        this.erroridcode = "请输入正确的身份证号";
        return false;
      }
      this.erroridcode = "";
    },
    //两次密码验证
    valiidpassword() {
      if (this.form.password2 == "") {
        this.errorpassword = "请再次输入密码";
        return false;
      }
      if (this.form.password2 !== this.form.password1) {
        this.errorpassword = "两次输入密码不一致";
        return false;
      }
      this.errorpassword = "";
    },
    valiidpassword2() {
      if (this.form2.password1 == "") {
        this.errorpassword = "请再次输入密码";
        return false;
      }
      if (this.form2.password1 !== this.form2.password) {
        this.errorpassword = "两次输入密码不一致";
        return false;
      }
      this.errorpassword = "";
    },

    //邮箱验证
    valiiderroremail() {
      let emailreg = new RegExp(
        "^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$"
      ); //邮箱正则
      if (this.form.erroremail == "") {
        this.erroremail = "请输入邮箱";
        return false;
      }
      if (!emailreg.test(this.form.email)) {
        this.erroremail = "邮箱格式不正确";
        return false;
      }
      this.erroremail = "";
    },
    valiiderroremail2() {
      let emailreg = new RegExp(
        "^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$"
      ); //邮箱正则
      if (this.form2.erroremail == "") {
        this.erroremail = "请输入邮箱";
        return false;
      }
      if (!emailreg.test(this.form2.email)) {
        this.erroremail = "邮箱格式不正确";
        return false;
      }
      this.erroremail = "";
    },
    //手机号验证
    valiiderrortel() {
      let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //手机正则
      if (this.form.tel == "") {
        this.errortel = "请输入手机号";
        return false;
      }
      if (!reg_tel.test(this.form.tel)) {
        this.errortel = "手机号格式不正确";
        return false;
      }
      //如果手机号没有问题请求验证码接口
      this.errtel = true;
      this.huoqucode();
      this.errortel = "";
    },
    //平台用户手机号验证

    valiiderrortel2() {
      let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //手机正则
      if (this.form2.tel == "") {
        this.errortel = "请输入手机号";
        return false;
      }
      if (!reg_tel.test(this.form2.tel)) {
        this.errortel = "手机号格式不正确";
        return false;
      }
      this.errtel = true;
      this.huoqucode2();
      this.errortel = "";
    },
    //短信验证码验证
    valiiderrorCheckCode() {
      if (this.form.messageCheckCode == "") {
        this.errortel = "请输入短信验证码";
        return false;
      }
    },
    huoqucode() {
      let baseURL = process.env.VUE_APP_BASE_API;
      console.log(baseURL, 7777);
      //this.src = `${baseURL}v1.0/Account/GetBusinessCode?Mobile=${this.form.tel}`;
      console.log(this.src, 47555);
    },
    huoqucode2() {
      let baseURL = process.env.VUE_APP_BASE_API;
      console.log(baseURL, 7777);
      //this.src2 = `${baseURL}v1.0/Account/GetBusinessCode?Mobile=${this.form2.tel}`;
      console.log(this.src2, 47555);
    },
    //定时器函数
    codeTime() {
      this.countTime = 60;
      var timer = setInterval(() => {
        this.countTime -= 1;
        if (this.countTime == 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    sendCode() {
      if (this.stopSend) {
        return;
      }
      this.stopSend = true;
      let data = {
        tel: this.form.tel,
        checkCode: this.form.checkCode,
        messageCheckCode: null
      };
      console.log(data, 255);
      //请求
      this.request({
        url: "/v1.0/Account/BusinessUserSendMessage",
        method: "POST",
        data: data
      })
        .then(res => {
          if (res.data == "ok") {
            console.log(res, 88888);
            this.errcode = true;
            this.codeTime();
          } else {
            this.$toast.fail(res.data);
          }
          this.stopSend = false;
        })
        .catch(err => {});
    },

    sendCode2() {
      if (this.stopSend) {
        return;
      }
      this.stopSend = true;
      let data = {
        tel: this.form2.tel,
        checkCode: this.form2.checkCode,
        messageCheckCode: null
      };
      this.request({
        url: "/v1.0/Account/BusinessUserSendMessage",
        method: "POST",
        data: data
      })
        .then(res => {
          if (res.data == "ok") {
            console.log(res, 88888);
            this.errcode = true;
            this.codeTime();
          } else {
            this.$toast.fail(res.data);
          }
          this.stopSend = false;
        })
        .catch(err => {});
    },
    getbumenlist() {
      this.request({
        url: "/v1.0/Account/getSubOrganizationList",
        method: "GET"
      }).then(res => {
        console.log(res, 777);
        let arr = [];
        res.data.forEach(item => {
          console.log(item, 778999);
          if (item.sort != 0) {
            arr.push(item);
          }
        });
        arr.forEach(element => {
          this.bumencolumns.push({ value: element.value, text: element.text });
        });
      });
    },
    getkeshilist(data) {
      this.request({
        url: `/v1.0/Account/getSubOrganizationList?parentid=${data}`,
        method: "GET"
      }).then(res => {
        res.data.forEach(element => {
          this.keshicolumns.push({ value: element.value, text: element.text });
        });
      });
    },
    bumenonConfirm(val) {
      console.log(val, 258);
      this.bumenid = val.text;
      this.bumenval = val.value;
      this.isbumen = false;
      this.getkeshilist(val.value);
    },
    keshiConfirm(val) {
      console.log(val, 999);
      this.keshiid = val.text;
      this.form2.orgId = val.value;
      this.iskeshi = false;
    },
    zhiwuConfirm(val) {
      console.log(val);
      this.form2.posinion = val.value;
      this.zhiwuid = val.text;
      this.iszhiwu = false;
    }
  },

  created() {
    this.getbumenlist();

    //请求部门
  }
};
</script>

<style lang="scss" scoped>
.ClueQuery {
  position: absolute;
  top: 8vh;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow-x: hidden;
  background-color: rgb(247, 248, 250);
  z-index: 1;
}
.fout-img {
  margin-top: 8vh;
  width: 100%;
  height: 600px;
  img {
    width: 100%;
    height: 100%;
  }
}
.yanzhengma {
  background: #fff;
  padding: 10px 16px;
  display: flex;
}
.codebox {
  img {
    width: 100%;
    height: 100%;
  }
}
.el-input {
  width: 35%;
}
.codebut {
  margin-left: 15px;
  border: 1px solid #ced4da;
  width: 96px;
  height: 40px;
  color: #ced4da;
  text-align: center;
  line-height: 35px;
  border-radius: 4px;
}
</style>
